module.exports = __webpack_public_path__ + "img/1545404613.7812c650.jpg";